/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {State, StepStatus} from "ui/feature/root/FormReducer";


export default function UseStaffSelectAvailable(state: State) {
    return React.useMemo(() => {
        switch (state.uploadStepStatus) {
            case StepStatus.SUCCESS:
                return true;
            default:
                return false;
        }
    }, [state.uploadStepStatus]);
}